import React from 'react'
import styled from 'styled-components'
import stand2 from '../assets/stand (2).jpg'
import stand3 from '../assets/stand (3).jpg'
import stand4 from '../assets/stand (4).jpg'
import { FaMapMarkerAlt } from "react-icons/fa";

const locations = [
    {
        id: 1,
        name: "Esso Ryen",
        description: "Her finner du oss i hjertet av Oslo, på Mathallen. Vår stand er fylt med ferske norske jordbær, bringebær og moreller. Kom innom for en smaksopplevelse eller ta med deg bær hjem til din neste middag eller dessert.",
        address: "Enebakkveien 139, 0680 Oslo",
        image: stand4
    },
    {
        id: 2,
        name: "Majorstuen Torg",
        description: "Vår stand på Majorstuen Torg er perfekt for de som er på farten. Her kan du raskt plukke med deg en eske med ferske bær til en sunn snack eller en deilig dessert.",
        address: "Kirkeveien 59, 0364 Oslo",
        image: stand3
    },
    {
        id: 3,
        name: "Bryn Senter",
        description: "Besøk oss i Bryn Senter for å oppleve vår hyggelige stand ved inngangen til Bryn Senter. Vi tilbyr bær fra både Norge og utlandet, og du kan alltid regne med et godt tilbud og et smil.",
        address: "Østensjøveien 79, 0667 Oslo",
        image: stand4
    },
    {
        id: 4,
        name: "Storo Storsenter",
        description: "Her finner du oss på Storo. Vår stand er fylt med ferske norske jordbær, bringebær og moreller. Kom innom for en smaksopplevelse eller ta med deg bær hjem til din neste middag eller dessert.",
        address: "Vitaminveien 7, 0485 Oslo",
        image: stand2
    }
];

const StandsPage = () => {

    return (
        <div className='container'>
            <h1 className='section-title' id='stands'>Våre Stands</h1>
            <div className='section-border'></div>

            <Section>
                <p className='section-description'>
                    Vi er stolte av å bringe de ferskeste og mest smakfulle bærene rett til deg! 
                    Her kan du finne oversikten over våre stands, hvor vi selger våre håndplukkede norske jordbær, bringebær og moreller.
                    Er du i Oslo, er det alltid en stand i nærheten hvor du kan oppleve sommerens smaker.
                </p>
                <p className='section-description'>
                    Besøk oss for å finne de beste bærene til ditt sommerkjøkken, og la deg friste av smaken av ekte norsk sommer!
                </p>

                <GridContainer>
                    {locations.map((location) => (
                        <LocationCard key={location.id}>
                            <ImageContainer>
                                <img src={location.image} alt={location.name} />
                            </ImageContainer>

                            <Info>
                                <LocationName>{location.name}</LocationName>
                                <Description>{location.description}</Description>
                                <Address>
                                    <FaMapMarkerAlt color="#2d6a4f" />
                                    {location.address}
                                </Address>
                            </Info>

                        </LocationCard>
                    ))}
                </GridContainer>
            </Section>
            
            
        </div>
    )
}

export default StandsPage

const Section = styled.section`
    .section-description {
        text-align: center;
        margin-bottom: 1rem;
        font-size: 16px;
    }
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }
`;

const LocationCard = styled.div`
    display: flex;
    gap: 1.5rem;
    padding: 1.5rem;


    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 1rem;
    }
`;

const ImageContainer = styled.div`
    width: 60%;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media (max-width: 768px) {
        width: 100%;
    }

    @media (max-width: 1024px) {
        width: 100%;
    }
`;

const Info = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
`;

const LocationName = styled.h2`
    font-size: 1.5rem;
    color: #b22222;
    margin-bottom: 0.5rem;
`;

const Description = styled.p`
    font-size: 1rem;
    color: #4a4a4a;
    margin-bottom: 0.8rem;
    text-align: flex-start;
`;

const Address = styled.div`
    font-size: 0.9rem;
    color: #2d6a4f;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: bold;
    align-self: flex-start;
    justify-self: flex-end;
`;